import { PositionDiscardReason } from '../enums/position-discard-reason.enum';

export interface PositionValidationResult {
    isValid: boolean;
    reasons: PositionDiscardReason[]; // empty when the position is valid
}

/**
 * Corrupt frame episode of a device, written by standard-position-ms to the Redis shared with stork-events-ms.
 * An episode starts with the first discarded position whose reason is in CORRUPT_FRAME_REASONS and
 * ends with the next valid position.
 */
export interface CorruptFrameEpisode {
    deviceId: number;
    episodeId: string; // String(firstDiscardAt): tells apart episodes of the same device
    firstDiscardAt: number; // epoch ms, standard-position-ms server clock (device clocks may be corrupt)
    lastDiscardAt: number;
    closedAt?: number; // only set on episodes pushed to the closed list
    discardCount: number;
    reasons: Partial<Record<PositionDiscardReason, number>>;
    lastValidLatitude?: string; // last valid position known by Dolphin, the discarded one may be 0,0
    lastValidLongitude?: string;
}
